var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"graficoContainer"}},[(_vm.hasTitulo)?_c('span',{staticClass:"TituloGrafico"},[_vm._v(_vm._s(_vm.titulo))]):_vm._e(),_c('div',{ref:"treeMap",staticClass:"treeMap",attrs:{"id":_vm.uuid}})])}
var staticRenderFns = []

export { render, staticRenderFns }